import { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Collapse,
  Flex,
  FormLabel,
  Link,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { useAppDispatch, useAppSelector } from '../../../../store/redux/hooks';
import {
  clearAllNotificationMessages,
  syncNotificationMessagesToStampCount,
} from '../../../../store/redux/slices/template.slice';
import NotificationMessageInput from './NotificationMessageInput';
import RemoveButton from '../RemoveButton';

const NotificationMessages = () => {
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(true);
  const { notificationMessages, stampCount } = useAppSelector(
    (s) => s.template
  );
  const numericStampCount = Math.min(Math.max(Number(stampCount) || 2, 2), 12);
  const messagesToShow = useMemo(
    () => notificationMessages.slice(0, numericStampCount + 1),
    [notificationMessages, numericStampCount]
  );

  const hasAnyPopulatedMessage = useMemo(
    () =>
      messagesToShow.some(
        (msg) =>
          (msg.label != null && String(msg.label).trim() !== '') ||
          (msg.slot != null && String(msg.slot).trim() !== '')
      ),
    [messagesToShow]
  );

  useEffect(() => {
    dispatch(syncNotificationMessagesToStampCount());
  }, [dispatch, stampCount]);

  return (
    <Box
      p={3}
      border="1px solid"
      borderColor="primaryBackground"
      borderRadius="md"
      mb={3}
      position="relative"
    >
      <Flex
        alignItems="center"
        justify="space-between"
        cursor="pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FormLabel variant="templateBuilderLabel" m={0} fontWeight="500">
          Notification Messages
        </FormLabel>
        {isOpen ? (
          <ChevronUpIcon boxSize="20px" />
        ) : (
          <ChevronDownIcon boxSize="20px" />
        )}
      </Flex>
      <Collapse in={isOpen}>
        {messagesToShow.map((message, index) => (
          <NotificationMessageInput
            key={message.id}
            message={message}
            index={index}
          />
        ))}
      </Collapse>
      {isOpen && (
        <Box mt={4}>
          <RemoveButton
            label="Remove all"
            isDisabled={!hasAnyPopulatedMessage}
            onClick={() => dispatch(clearAllNotificationMessages())}
          />
        </Box>
      )}
    </Box>
  );
};

export default NotificationMessages;
